module.exports = __webpack_public_path__ + "static/khachanov-gray-e36f7f419bb89a51f8101b307087b203.png";